// extracted by mini-css-extract-plugin
module.exports = {"select":"_8Gr2g"};